class ProductSiblings extends HTMLElement {
  constructor() {
    super();
    document.body.addEventListener('product:variant-change', (event) => {
      this.onVariantChange(event.detail.currentVariant);
    });

    this.initSiblings();
  }

  initSiblings() {
    this.searchParams = new URLSearchParams(window.location.search);
    this.sizeParam = this.searchParams.get('size');
    if (!this.sizeParam) return;

    this.getData();
    const selectedSize = this.sizeParam;

    this.updateSiblings(selectedSize);
  }

  onVariantChange(currentVariant) {
    // TODO: what happens if a specific size + width combo does not exist? Reset the whole form perhaps?
    this.getData();

    const selectedSize = currentVariant[`option${this.sizeOptionId + 1}`];

    this.updateSiblings(selectedSize);
  }

  getData() {
    this.data = this.data || JSON.parse(this.querySelector('.product-siblings-data').textContent);
    this.siblings = this.siblings || this.data.siblings;
    this.availableSiblings = this.siblings.filter((sibling) => sibling.available === true);
    this.options = this.data.options;
    this.sizeOptionId = this.options.findIndex((element) => element === "Size");
  }

  updateSiblings(selectedSize) {
    // Select elements to update (visually + the link)
    const optionSelectors = document.querySelectorAll('.single-option-selector__option--color');
    const optionSelectorLinks = document.querySelectorAll('.product__siblings__option');
    // Remove disabled class from all elements
    optionSelectors.forEach((option) => option.parentElement.classList.remove('single-option-selector__option-wrap--disabled'));
    // Update link href to include size parameter
    optionSelectorLinks.forEach((element) => {
      element.search = '';
      element.search = `?size=${selectedSize}`;
    });

    this.availableSiblings.forEach((sibling, index) => {
      const availableSizes = sibling.variants.map((variant) => {
        return variant[`option${this.sizeOptionId + 1}`];
      });
      // Check if size is sold out (e.g. it's not in the available size array)
      if (!availableSizes.includes(selectedSize)) {
        // Add disabled class to element
        optionSelectors[index].parentElement.classList.add('single-option-selector__option-wrap--disabled');
      }
    });    
  }
}

customElements.define('product-siblings', ProductSiblings);
